const isValidEmail = (email) => {
    let emailRegexPattern = /^\S+@\S+\.\S+$/
    return emailRegexPattern.test(email)
}

const isValidPhoneNumber = (email) => {
    let phoneRegexPattern = /^\+1\d{10}$/
    return phoneRegexPattern.test(email)
}

export {
    isValidEmail,
    isValidPhoneNumber
}